// LoginView.tsx — full-screen login gate rendered by App() whenever GET /api/session
// reports authenticated:false (server-side auth is on and no valid session cookie is
// present yet). Single password field, no username (single-user app).
import { useState } from 'preact/hooks';
import { ApiError, postLogin } from '../lib/api.js';

function errorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.status === 401) return 'Falsches Passwort';
    if (err.status === 429) return 'Zu viele Versuche — bitte warten';
    return err.message;
  }
  return 'Unbekannter Fehler beim Anmelden.';
}

export function LoginView({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: SubmitEvent) {
    event.preventDefault();
    if (!password || submitting) return;
    setSubmitting(true);
    setError(null);
    try {
      await postLogin(password);
      onLoggedIn();
    } catch (err) {
      setError(errorMessage(err));
      setPassword('');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div class="login-screen">
      <form class="card login-card" onSubmit={handleSubmit}>
        <h2>ETF Cockpit</h2>
        <div class="field">
          <label for="login-password">Passwort</label>
          <input
            id="login-password"
            type="password"
            autofocus
            autocomplete="current-password"
            value={password}
            disabled={submitting}
            onInput={(e) => setPassword((e.target as HTMLInputElement).value)}
          />
        </div>
        {error ? (
          <div class="banner banner-error" role="alert">
            <span>{error}</span>
          </div>
        ) : null}
        <button type="submit" class="btn btn-primary btn-block" disabled={submitting || !password}>
          {submitting ? <span class="spinner" /> : 'Anmelden'}
        </button>
      </form>
    </div>
  );
}
